<template>
	<div>
		<FormCard :medicao="medicao" />

		<div class="flex w-full mt-4 justify-between gap-4">
			<NewTag
				:active="tab === 'medicao'"
				class="!w-1/2 !py-1"
				@click="setTab('medicao')"
			>
				{{ $t('measurements') }}
			</NewTag>
			<NewTag
				:active="tab === 'mato'"
				class="!w-1/2 !py-1"
				@click="setTab('mato')"
			>
				{{ $t('matoCompeticao') }}
			</NewTag>
		</div>

		<div
			v-show="tab === 'medicao'"
			class="flex gap-4 flex-col"
		>
			<InputText
				v-model="medicao.dap"
				:label="$t('hbd')"
			/>
			<InputText
				v-model="medicao.ht"
				:label="$t('ht')"
			/>
			<InputText
				v-model.number="medicao.diametroCopa"
				:label="$t('treetopDiameter')"
				type="number"
			/>
			<Dropdown
				v-model="medicao.categoriaDaArvore"
				:label="$t('treeCategory')"
				:options="categorias"
			/>
			<Dropdown
				v-model="medicao.categoriaFitossanidade"
				:label="$t('fitoCategory')"
				:options="categoriasFito"
			/>
			<div class="flex items-center gap-4">
				<v-slider
					v-model="medicao.intensidadeFitossanidade"
					color="#34617E"
					track-color="#34617E"
					max="100"
					min="0"
				/>
				<span class="m-0 p-2 text-[#737576] text-xs leading-4 border border-[#737576] rounded-md"
					>{{ medicao.intensidadeFitossanidade }} %</span
				>
			</div>
		</div>
		<div
			v-show="tab === 'mato'"
			class="flex flex-col gap-2"
		>
			<h1 class="title">
				{{ $t('matoCompeticaoLinha') }}
			</h1>
			<label class="text-label">{{ $t('areaCoberta') }}</label>
			<div class="flex items-center gap-4">
				<v-slider
					v-model="medicao.coberturaMatoLinha"
					color="#34617E"
					track-color="#34617E"
					max="100"
					min="0"
				/>
				<span class="m-0 p-2 text-[#737576] text-xs leading-4 border border-[#737576] rounded-md"
					>{{ medicao.coberturaMatoLinha }} %</span
				>
			</div>
			<label class="text-label">{{ $t('alturaDoMato') }}</label>
			<div class="flex items-center gap-4">
				<v-slider
					v-model="medicao.alturaMatoLinha"
					color="#34617E"
					track-color="#34617E"
					max="100"
					min="0"
				/>
				<span class="m-0 p-2 text-[#737576] text-xs leading-4 border border-[#737576] rounded-md"
					>{{ medicao.alturaMatoLinha }} %</span
				>
			</div>

			<label class="text-label">{{ $t('tipoMatoDominante') }} </label>
			<Dropdown
				v-model="medicao.tipoMatoDominante"
				:options="tiposMato"
			/>

			<label class="text-label">{{ $t('tipoMatoAssociado') }}</label>
			<Dropdown
				v-model="medicao.tipoMatoAssociado"
				:options="tiposMato"
			/>

			<h1 class="title">
				{{ $t('matoCompeticaoEntrelinha') }}
			</h1>

			<label class="text-label">{{ $t('areaCoberta') }}</label>
			<div class="flex items-center gap-4">
				<v-slider
					v-model="medicao.coberturaMatoEntrelinha"
					color="#34617E"
					track-color="#34617E"
					max="100"
					min="0"
				/>
				<span class="m-0 p-2 text-[#737576] text-xs leading-4 border border-[#737576] rounded-md"
					>{{ medicao.coberturaMatoEntrelinha }} %</span
				>
			</div>
			<label class="text-label">{{ $t('alturaDoMato') }}</label>
			<div class="flex items-center gap-4">
				<v-slider
					v-model="medicao.alturaMatoEntrelinha"
					color="#34617E"
					track-color="#34617E"
					max="100"
					min="0"
				/>
				<span class="m-0 p-2 text-[#737576] text-xs leading-4 border border-[#737576] rounded-md"
					>{{ medicao.alturaMatoEntrelinha }} %</span
				>
			</div>

			<label class="text-label">{{ $t('tipoMatoDominante') }}</label>
			<Dropdown
				v-model="medicao.matoDominanteEntrelinha"
				:options="tiposMato"
			/>

			<label class="text-label">{{ $t('tipoMatoAssociado') }}</label>
			<Dropdown
				v-model="medicao.matoAssociadoEntrelinha"
				:options="tiposMato"
			/>
		</div>

		<div class="flex flex-col mt-4 gap-4">
			<div v-if="medicao.validacaoConsistencia.length">
				<div class="flex gap-2 flex-col">
					<Message
						v-for="validacao in medicao.validacaoConsistencia"
						:key="validacao"
						size="sm"
						:title="getMessages(validacao).title"
						:description="getMessages(validacao).message"
						type="info"
					/>
				</div>
			</div>
			<div v-if="medicao.insights.length">
				<div class="flex gap-2 flex-col">
					<Message
						v-for="insight in medicao.insights"
						:key="insight"
						size="sm"
						:title="insight.message"
						:description="`${insight.source.toFixed(4)} cm`"
						type="warning"
					/>
				</div>
			</div>
		</div>

		<div class="flex gap-4 py-4">
			<Button
				label="Excluir"
				color="trv-error"
				outlined
				@click="deleteIntent = true"
			/>
			<Button
				:disabled="disabled"
				label="Salvar alterações"
				@click="emit('save')"
			/>
		</div>

		<Modal v-show="deleteIntent">
			<div class="bg-white p-4 rounded-lg">
				<p class="text-base">
					{{ $t('excluirMedicao') }}
				</p>
				<div class="flex gap-4 justify-between mt-4">
					<Button
						label="Excluir"
						color="trv-error"
						outlined
						@click="
							emit('delete')
							deleteIntent = false
						"
					/>
					<Button
						label="Cancelar"
						color="trv-secondary"
						outlined
						@click="deleteIntent = false"
					/>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script setup>
import { ref } from 'vue'
import { ValidacaoConsistenciaMessagesFactory } from '../../factories/ValidacaoConsistenciaMessagesFactory'
import Button from '../Button/Button.vue'
import Dropdown from '../Dropdown/Dropdown.vue'
import InputText from '../InputText/InputText.vue'
import Modal from '../Modal/Modal.vue'
import NewTag from '../NewTag/NewTag.vue'
import Message from '../ui/message/Message.vue'
import FormCard from './FormCard.vue'

const emit = defineEmits(['delete', 'save'])
const deleteIntent = ref(false)

const props = defineProps({
	medicao: { type: Object, required: true },
	categorias: { type: Array, required: true },
	categoriasFito: { type: Array, required: true },
	disabled: { type: Boolean, default: false },
	viewing: { type: Boolean, default: false },
})

const tab = ref('medicao') //medicao ou mato

function setTab(value) {
	tab.value = value
}

function getMessages(validacao) {
	console.log('aquiiii :', validacao)
	return ValidacaoConsistenciaMessagesFactory.make(validacao).long
}

const tiposMato = ref([
	{ label: 'Sem mato', value: props.viewing ? 'SEMMATO' : 'Sem mato' },
	{
		label: 'Germinação indefinida',
		value: props.viewing ? 'GERMINACAOINDEFINIDA' : 'Germinação indefinida',
	},
	{ label: 'Folha larga', value: props.viewing ? 'FOLHALARGA' : 'Folha larga' },
	{ label: 'Cipó', value: props.viewing ? 'CIPO' : 'Cipó' },
	{ label: 'Gramínea', value: props.viewing ? 'GRAMINEA' : 'Gramínea' },
])
</script>

<style>
.v-messages.theme--light {
	display: none;
}

.title {
	color: var(--Neutral-Colors-Neutral-Black, #272728);

	/* text-H5 */
	font-family: 'Open Sans';
	font-size: 24px;
	font-style: normal;
	font-weight: 700;
	line-height: 28px;
	/* 116.667% */
	letter-spacing: -1px;
}
</style>
